// src/components/layout/MobileHeader.jsx
import { HiMenu } from 'react-icons/hi';
import logo from '../../assets/logo_logo.svg'; // Импортируем логотип
import ThemeToggle from '../ui/ThemeToggle';

const MobileHeader = ({ onMenuClick }) => {
  return (
    // ИЗМЕНЕНИЯ: 
    // 1. bg-slate-800 -> bg-slate-900 (цвет как у сайдбара)
    // 2. border-slate-700 -> border-slate-700/50 (прозрачность границы как у сайдбара)
    <header className="lg:hidden bg-slate-900 p-4 flex items-center justify-between border-b border-slate-700/50 sticky top-0 z-20">
      
      {/* Контейнер для логотипа и текста */}
      <div className="flex items-center gap-3">
        <img src={logo} alt="Hedger Logo" className="w-8 h-8 object-contain" />
        <span className="text-white text-xl font-bold tracking-tight pb-1">Hedger</span>
      </div>

      <div className="flex items-center gap-2">
        <ThemeToggle shortLabels size="sm" className="w-16" />
        <button onClick={onMenuClick} className="p-1 text-gray-400 hover:text-white transition-colors">
          <HiMenu className="w-7 h-7" />
        </button>
      </div>
    </header>
  );
};

export default MobileHeader;
